import { getRequestUrlFromRemote } from '@flex-packages/remote-core';
import { generateThumbnailRemote } from '../../apis/thumbnail/apis/thumbnail-generate-controller-api.mjs';
import { ThumbnailGenerateFallbackType } from '../../apis/thumbnail/models/thumbnail-generate-fallback-type.mjs';

function normalizeThumbnailSize(params) {
  const { size } = params;
  if (size < 120) {
    return 120;
  }
  if (size < 240) {
    return 240;
  }
  if (size < 480) {
    return 480;
  }
  return 960;
}
function makeImageThumbnailUrl({
  fileKey,
  size,
  exact = false
}) {
  const normalizedSize = exact ? size : normalizeThumbnailSize({ size });
  return getRequestUrlFromRemote(generateThumbnailRemote, {
    fileKey,
    size: normalizedSize,
    fallbackType: ThumbnailGenerateFallbackType.Original
  });
}

export { makeImageThumbnailUrl, normalizeThumbnailSize };
//# sourceMappingURL=makeImageThumbnailUrl.mjs.map
